<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
      <input
        type="checkbox"
        class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
        formControlName="advanced"
        id="advanced"
      />
      <label
        for="advanced"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.integrations.advancedConfiguration' | translate }}
      </label>
    </div>

    <div *ngIf="form.get('advanced')?.value" class="gw-space-y-4">
      <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
          formControlName="sandbox"
          id="sandbox"
        />
        <label
          for="sandbox"
          class="gw-text-sm gw-font-medium gw-text-text-primary"
        >
          {{ 'features.integrations.sandboxMode' | translate }}
        </label>
      </div>
      <div class="gw-mb-4">
        <label
          for="integration-key"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.integrationKey' | translate }}
        </label>
        <input
          id="integration-key"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="integration-key"
          [placeholder]="
            'features.integrations.integrationKeyPlaceholder' | translate
          "
        />
      </div>
      <div class="gw-mb-4">
        <label
          for="x-token"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.xToken' | translate }}
        </label>
        <input
          id="x-token"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="x-token"
          [placeholder]="'features.integrations.xTokenPlaceholder' | translate"
        />
      </div>
      <div class="gw-mb-4">
        <label
          for="authentication-key"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.authenticationKey' | translate }}
        </label>
        <input
          id="authentication-key"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="authentication-key"
          [placeholder]="
            'features.integrations.authenticationKeyPlaceholder' | translate
          "
        />
      </div>
    </div>

    <div class="gw-mb-4">
      <label
        for="establishmentId"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.establishmentId' | translate }}
      </label>
      <input
        id="establishmentId"
        type="number"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="establishmentId"
        [placeholder]="
          'features.integrations.establishmentIdPlaceholder' | translate
        "
      />
      <small
        *ngIf="
          form.get('establishmentId')?.invalid &&
          form.get('establishmentId')?.touched
        "
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.establishmentIdRequired' | translate }}
      </small>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
